import type { ModuleFolder, ModuleFolderMapping } from '@/models/RobotFinder';
import { ModuleIdNameMapping } from '@/models/Robot';
import RobotFinderApi from '@/api/RobotFinderApi';

export async function getLatestRobotModules(): Promise<
  ModuleFolderMapping | undefined
> {
  try {
    const data = await RobotFinderApi.getModuleFolderMapping();
    const entries = Object.entries(data) as [string, ModuleFolder][];

    const filtered = Object.fromEntries(
      entries.filter(
        ([, module]) =>
          module.moduleType !== 'Clamp' &&
          !module.legacy &&
          module.isLatestModuleOfName,
      ),
    ) as ModuleFolderMapping;

    return filtered;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    console.error(err);
    return undefined;
  }
}

export function getModuleIdNameMapping(
  moduleFolderMapping: ModuleFolderMapping,
) {
  return Object.keys(moduleFolderMapping)
    .map((id) => {
      return {
        id,
        name: moduleFolderMapping[id].moduleName.replace('-KM', ''),
      };
    })
    .sort((a, b) => a.name.localeCompare(b.name));
}

export function getModuleNamesAsCommaSeparatedString(
  moduleIds: number[],
  moduleIdNameMapping: ModuleIdNameMapping[],
) {
  return moduleIds
    .map((id: number) =>
      moduleIdNameMapping
        .find((mapping: { id: string }) => parseInt(mapping.id, 10) === id)
        ?.name?.replace('-KM', ''),
    )
    .filter((name) => name !== undefined)
    .join(', ');
}
